/**
 * @generated SignedSource<<5497ba802b9ee58e694b68fe30323ca3>>
 * @relayHash 6a00c1df44ed1ed8ed55a1cbe73bf142
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1e3c298136c6c01b050498f17e4f135d0f928cb7d8addca4b9a7e57c77ba2461

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1e3c298136c6c01b050498f17e4f135d0f928cb7d8addca4b9a7e57c77ba2461",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
